// Export all API modules
import { clearCache, invalidateRepositoryCache } from "./bitbucketCore";
import authApi from "./authApi";
import repositoryApi from "./repositoryApi";
import variablesApi from "./variablesApi";
import pipelinesApi from "./pipelinesApi";

// Export everything from each module
export {
  // Auth exports
  getAuthUrl,
  exchangeCodeForToken,
  refreshToken,
} from "./authApi";

export {
  // Repository exports
  getUserRepositories,
  getWorkspaces,
  getRepositoryBranches,
} from "./repositoryApi";

export {
  // Variables exports
  getRepositoryVariables,
  createRepositoryVariable,
  updateRepositoryVariable,
  deleteRepositoryVariable,
  bulkCreateVariables,
  bulkUpdateVariables,
  bulkDeleteVariables,
  copyVariablesToRepositories,
} from "./variablesApi";

export {
  // Pipeline exports
  getRepositoryPipelines,
  runPipeline,
  bulkRunPipelines,
  getRepositoryPipelineRuns,
  getPipelineRunDetails,
  getPipelineSteps,
  triggerPipelineStep,
  stopPipelineRun,
} from "./pipelinesApi";

// Export cache utilities from core
export { clearCache, invalidateRepositoryCache };

// Export default with all API functions combined
const api = {
  ...authApi,
  ...repositoryApi,
  ...variablesApi,
  ...pipelinesApi,
  clearCache,
  invalidateRepositoryCache,
};

export default api;
